import React, {useEffect, useState} from "react";
import PermitContent from "./PermitContent";
import "./page.css";
import {
  Card,
  CardContent,
  Grid,
  CardHeader,
  IconButton,
  Badge,
} from "@material-ui/core";
import {makeStyles} from "@material-ui/core";
import {
  Button,
  Container,
  Divider,
} from "@material-ui/core";
import Text from "../Text/Text";
import {
  ArrowForwardIosRounded,
  CancelRounded,
  DeleteRounded,
  Edit,
  ShoppingCart,
} from "@material-ui/icons";
import {useSelector} from "react-redux";
import {useDispatch} from "react-redux";
import CheckoutPermit from "./CheckoutPermit";
import moment from "moment";

import BuyPerimtsEditOrderModal from "../Modals/buypermits/BuyPermitsExitOrderModal";
import AllowedVehicleAlertModal from "../Modals/buypermits/AllowedVehicleAlertModal";
import {
  getBuyPermitPaymentMethods,
  getTaxRateOrder,
  hideBuyPermitsExitOrderModal,
  hideBuyPermitThankYouModal,
  resetBuyPermitSelectedPermit,
  showAllowedVehicleAlertModal,
  showBuyPermitsExitOrderModal,
} from "../../store/buyPermits/action";
import {useHistory} from "react-router";
import {RouteService} from "../../services/route.service";
import {getUserContextData} from "../../store/login/selector";
import {getProfileData} from "../../store/profile/selector";
import VehicleCheckboxList from "../VehicleCheckboxList/VehicleCheckboxList";

const useStyles = makeStyles((theme) => ({
  p5: {
    padding: "5px",
  },
  root: {
    minHeight: "calc(100vh - 302px)",
    width: "100%",
  },
  rightBox: {
    height: "250px",
    width: "500px",
    backgroundColor: theme.palette.primary.main,
    border: "2px solid black",
    borderRadius: "10px",
    marginLeft: "14%",
  },
  rightGrid: {
    justifyContent: "center",
    alignItems: "center",
  },
  toolbarContainer: {
    marginBottom: "10px",
    position: "relative",
    padding: "10px",
  },
  rightIconsContainer: {
    position: "absolute",
    right: "20px",
    top: 0,
  },
  dflex: {
    display: "flex",
  },
  alignBase: {
    alignItems: "baseline",
  },
  fGap: {
    gap: "10px",
  },
  secondContainer: {
    textAlign: "center",
  },

  active: {
    background: "gray",
  },
  vehicleCardHeader: {
    background: "#20419a",
    color: "white",
  },
  vehiclesUl: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
    fontSize: "11px",
  },
  thirdStepFirstDivChild: {
    background: theme.palette.primary.main,
    padding: "4px",
  },
  stepperPadding: {
    padding: "15px",
  },
  firstStepFirstChildMaindiv: {
    padding: "6px",
    width: "auto",
    borderRadius: 9,
    color: "white",
    marginRight: "15px",
    height: "fit-content",
    border: "1px solid gray",
    textAlign: "center",
  },
  firstStepFirstChild: {
    background: theme.palette.primary.main,
    padding: "4px",
    width: "auto",
    color: "white",
    borderRadius: "2px",
  },
  tablehead: {
    background: "#20419a",
  },
  tableheadChild: {
    color: "white",
  },
  fWrap: {
    flexWrap: "wrap",
    width: "40px",
  },
  rightContainer: {
    marginLeft: "145px",
    minHeight: "20px",
  },
  rightContainerHeader: {
    background: theme.palette.primary.main,
    top: "0",
  },

  tableRow: {
    "&:hover": {
      backgroundColor: "gray !important",
    },
  },
  alignCenter: {
    alignItems: "center",
  },
  textField: {
    "& div": {
      padding: "7px 12px 10px",
    },
    width: "100%",
  },
  spaceTop: {
    marginTop: 25,
  },
  img: {
    width: 60,
  },
  link: {
    cursor: "pointer",
  },
  stateText: {
    paddingBottom: 8,
  },
  steptotalflex: {
    display: "flex",
  },
  w100: {
    width: "100%",
  },
  borderBottom: {
    borderBottom: "1px solid #a39b9b",
  },
  checkouttotal: {
    border: "1px solid black",
    borderRadius: "5px",
    boxShadow: "0px 0px 3px 1px rgba(0,0,0,0.75)",
    width: "300px",
    position: "absolute",
    right: "5px",
  },
  checkoutgrid: {
    position: "absolute",
    right: "10px",
  },
  checkoutvechile: {
    fontWeight: "600",
    fontSize: "15px",
    display: "flex",
  },
  checkoutfirstStepFirstChild: {
    background: theme.palette.primary.main,
    padding: "4px",
    width: "125px",
    color: "white",
    textAlign: "center",
  },
  checkoutdflex: {
    display: "flex",
    border: "1px solid gray",
    width: "100%",
  },
  checkoutdflextable: {
    display: "flex",
  },
  checkoutml: {
    marginLeft: "20px",
  },
  checkoutinstruction: {
    border: "1px solid black",
    borderRadius: "5px",
    boxShadow: "0px 0px 3px 1px rgba(0,0,0,0.75)",
    width: "350px",
    position: "absolute",
    top: "250px",
    right: "5px",
  },
  checkoutsubmit: {
    top: "240px",
    width: "290px",
  },
  checkoutchangedflex: {
    display: "flex",
    justifyContent: "space-between",
  },
  checkoutTermandCondition: {
    position: "relative",
    top: "235px",
    width: "288px",
    textAlign: "center",
    color: "black",
  },

  backgroundtheme: {
    color: theme.palette.primary.main,
  },
}));

export default function ViewPermitCart(props) {
  const {StylingItem, handletoggleAddPermitPage, selectedDate, permitType, setPermitType} = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [showVehicleCheckboxList, setShowVehicleCheckboxList] = useState(false);
  const [editingVehicles, setEditingVehicles] = useState([]);
  const [editingPermit, setEditingPermit] = useState(null);
  const [isOpenAllowedVehicleAlertModal, setIsOpenAllowedVehicleAlertModal] = useState(false);
  const user = useSelector(getUserContextData);

  const getBuyPermitsExitOrderModal = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitsExitOrderModal
  );
  const getBuyPermitSelectedPermitsState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitSelectedPermits
  );

  const [isOpenExitOrderModal, setExitOrderModal] = useState(getBuyPermitsExitOrderModal);
  const [selectedPermitData, setSelectedPermitData] = useState(getBuyPermitSelectedPermitsState);
  const permitTaxRatePrice = useSelector((state) => state?.exitOrderReducer?.buyPermitTaxRatePrice);
  const profileStore = useSelector(getProfileData);
  const allVehicles = profileStore?.endUserAccountEntity?.person?.vehicles?.filter(item => !item.inactive) || [];
  const history = useHistory();

  const driverStatus =
    profileStore &&
    profileStore?.endUserAccountEntity?.driverAttributes?.filter(
      (item) => {
        if (item?.name === "Status") {
          return item;
        }
      }
    );

  const driverBAStatus = profileStore &&
    profileStore?.endUserAccountEntity?.driverAttributes?.map((item => {
      if (item.name !== 'VIP') {
        return item.value
      }
    }))

  const withoutUndefine = driverBAStatus?.filter((ele) => ele !== undefined)

  const status = Array.isArray(driverStatus) && driverStatus[0]?.value;

  useEffect(() => {
    dispatch(getTaxRateOrder(user?.user?.userGroup))
  }, [])

  useEffect(() => {
    setExitOrderModal(getBuyPermitsExitOrderModal);
  }, [getBuyPermitsExitOrderModal]);

  useEffect(() => {

    dispatch(getBuyPermitPaymentMethods({status: withoutUndefine, clientUserName: user?.user?.userGroup}));
    if (
      status === "undefined" ||
      (profileStore &&
        profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0)
    ) {
    } else {
      dispatch(getBuyPermitPaymentMethods({status: withoutUndefine, clientUserName: user?.user?.userGroup}));
    }
  }, []);

  useEffect(() => {
    setSelectedPermitData(getBuyPermitSelectedPermitsState);
  }, [getBuyPermitSelectedPermitsState]);

  const allowedVehicleModalState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitAllowedVehicleAlertState
  );

  useEffect(() => {
    setIsOpenAllowedVehicleAlertModal(allowedVehicleModalState);
  }, [allowedVehicleModalState]);

  const [permit, setpermit] = useState([]);
  const [showHide, setshowHide] = useState({});
  const [checkout, setCheckout] = useState(false);

  let totalPrice = 0;
  let totalFee = 0;
  let tax = 0;
  let grassTotal = 0;

  const stylingVal = {
    backgroundColor: StylingItem?.bodyColor,
    fontFamily: StylingItem?.font,
    color: StylingItem?.fontColor,
  };

  const gotochekoutCompoent = (e) => {
    dispatch(hideBuyPermitThankYouModal());
    setCheckout(true);
  };
  const handleShow = (permit) => {
    let tmpState = {...showHide};
    tmpState[permit] = true;
    setshowHide(tmpState);
  };
  const handleHide = (permit) => {
    let tmpState = {...showHide};
    tmpState[permit] = false;
    setshowHide(tmpState);
  };
  const handleDelete = async (permitId) => {
    let tmpState = [...permit];
    let tmpIndex = tmpState.findIndex((e) => e?.permit?.id === permitId);
    tmpState.splice(tmpIndex, 1);
    setpermit(tmpState);
    dispatch(resetBuyPermitSelectedPermit(tmpState));
  };

  const handleEdit = (_permitId, vehicleId, permitObj) => {
    setEditingVehicles([...vehicleId]);
    setEditingPermit(permitObj);
    setShowVehicleCheckboxList(true);
  };

  const handleSelectVehicle = (e, vehicle) => {
    let tmpVehicles = [...editingVehicles];
    const exists = tmpVehicles.some((v) => v.id === vehicle.id);

    if (exists) {
      tmpVehicles = tmpVehicles.filter((v) => v.id !== vehicle.id);
    } else if (tmpVehicles.length < editingPermit?.allowedNoVehicles) {
      tmpVehicles.push(vehicle);
    } else {
      e.target.checked = false;
      dispatch(showAllowedVehicleAlertModal(editingPermit?.allowedNoVehicles));
    }

    setEditingVehicles(tmpVehicles);
  };

  const handleSaveVehicles = () => {
    const updatedPermit = permit.map((p) =>
      p.permit.id === editingPermit?.id ? {...p, vehicles: editingVehicles} : p
    );
    setpermit(updatedPermit);
    dispatch(resetBuyPermitSelectedPermit(updatedPermit));
    setShowVehicleCheckboxList(false);
    setEditingVehicles([]);
    setEditingPermit(null);
  };

  const handleCancelVehicleEdit = () => {
    setEditingVehicles([]);
    setEditingPermit(null);
    setShowVehicleCheckboxList(false);
  };

  useEffect(() => {
    setPermitType("STD_PERMIT")
    setpermit(selectedPermitData);
  }, [selectedPermitData]);

  let price = 0;
  let fee = 0;
  Array.isArray(permit) &&
  permit.map((item) => {
    price = price + item?.price;
    fee = fee + item?.fee;
  });

  const CancelBuyPermitsExitOrderModal = () => {
    dispatch(hideBuyPermitsExitOrderModal());
  }

  const ConfirmBuyPermitsExitOrderModal = () => {
    history.push(RouteService.buyPermits);
    dispatch(hideBuyPermitsExitOrderModal());
    dispatch(resetBuyPermitSelectedPermit([]));
  }

  const cancelShowBuyPermitsExitOrderModal = () => {
    dispatch(showBuyPermitsExitOrderModal());
  }


  const validDatestart = (validDate, pushData, allData) => {
    if (allData?.permit?.permitType === permitType) {
      return moment(validDate)?.format("MM/DD/YYYY")
    } else {
      return moment(pushData)?.format("MM/DD/YYYY")
    }
  }

  const validSelectDate = (pusData, validDate, allData, endDate) => {
    if (allData?.permit?.permitType === "STD_PERMIT") {
      return moment(allData?.permit?.validEndDate)?.format("MM/DD/YYYY")
    } else if (pusData && allData?.permit?.permitType === "EFP") {
      const isAfter = moment(pusData).add(validDate, 'days').isAfter(endDate);
      if (isAfter === true) {
        return moment(allData?.permit?.validEndDate)?.format("MM/DD/YYYY")
      } else {
        return moment(pusData).add(validDate, 'days')?.format("MM/DD/YYYY")
      }
    }
  }

  return (
    <>
      <section style={stylingVal} className="page-wrapper page_mrb">
        {checkout ? (
          <CheckoutPermit
            selectedDate={selectedDate}
            setCheckout={setCheckout}
            handletoggleAddPermitPage={handletoggleAddPermitPage}
          />
        ) : (
          <Container maxWidth={"xl"}>
            <div>
              <div className={classes.toolbarContainer}>
                <div className={classes.innerFlex}>
                  <Text
                    color={props.StylingItem && props.StylingItem.bodyColor}
                    variant={"h6"}
                    className={classes.backgroundtheme}
                    style={{fontWeight: '600', fontSize: '1.6rem'}}
                  >
                    <h1 style={{margin: 0}}> Shopping Cart</h1>
                  </Text>
                  <Divider/>
                </div>
                <div
                  className={`${classes.rightIconsContainer} ${classes.dflex}`}
                >
                  <IconButton
                    title="ShoppingCart">
                    <Badge color="primary" badgeContent={selectedPermitData?.length || 0}>
                      <ShoppingCart
                        className={classes.backgroundtheme}
                        onClick={(e) => handletoggleAddPermitPage("view")}
                      />
                    </Badge>
                  </IconButton>
                  <IconButton
                    title="Cancel">
                    <CancelRounded
                      className={classes.backgroundtheme}
                      onClick={cancelShowBuyPermitsExitOrderModal}
                    />
                  </IconButton>
                </div>
              </div>

              <Grid container spacing={2}>
                <Grid item lg={8} md={8} xs={12}>
                  {permit?.length <= 0 ? (
                    <div className={classes.alignCenter}>
                      Your Shopping Cart is empty.
                    </div>
                  ) : (
                    <>
                      <Card style={{position: "relative"}}>
                        <CardHeader
                          style={{fontSize: 17}}
                          title={"PERMIT"}
                          className="card-header"
                        />
                        <CardContent className="scrollable-cart">
                          <>
                            {Array.isArray(permit) &&
                              permit?.map((row) => {
                                totalPrice = totalPrice + row?.permit?.price;
                                totalFee = totalFee + row?.permit?.fee;
                                tax = ((totalPrice + totalFee) * permitTaxRatePrice?.taxRate) / 100 || 0.00;
                                grassTotal = totalPrice + totalFee + tax;

                                return (
                                  <>
                                    <div
                                      tabIndex="0"
                                      onKeyDown={(event) => {
                                        if (event.key === "Tab") {
                                          handleShow(row?.permit?.id)
                                        }
                                      }}
                                      className="d-flex contentwrapper relat"
                                      onMouseOver={(e) =>
                                        handleShow(row?.permit?.id)
                                      }
                                      onMouseLeave={(e) =>
                                        handleHide(row?.permit?.id)
                                      }
                                    >
                                      <div>
                                        <PermitContent permit={row?.permit}/>
                                      </div>
                                      <div className="text-left">
                                        <p className="headinText">
                                          {`${row?.permit?.name}`} &nbsp;{" "}
                                        </p>

                                        <p>
                                          Good from{" "}
                                          {moment(
                                            validDatestart(row?.permit?.validStartDate, row?.permit?.tdate, row)
                                          )?.format(
                                            "MM/DD/YYYY"
                                          )}{" "}
                                          to{" "} {validSelectDate(row?.permit?.tdate, row?.permit?.validDays, row, row?.permit?.validEndDate)}
                                        </p>
                                        <p>Price : ${row?.permit?.price?.toFixed(2) || (0).toFixed(2)}</p>
                                        <p>Fees : ${row?.permit?.fee?.toFixed(2) || (0).toFixed(2)}</p>
                                        <div style={{fontSize: "16px"}}>
                                          <table>
                                            {Array.isArray(row?.vehicles) &&
                                              row?.vehicles?.map(
                                                (item, index) => {
                                                  return (
                                                    <>
                                                      <tr>
                                                        <th className="min-w80">
                                                          {" "}
                                                          Vehicles {index +
                                                          1}{" "}
                                                        </th>
                                                        <td>
                                                          {" "}
                                                          {`${item?.year} ${item?.color} ${item?.make?.name} ${item?.model}`}{" "}
                                                          {item?.licensePlate?.state?.code}{""} -{
                                                          item?.licensePlate
                                                            ?.number
                                                        }{" "}
                                                          VIN : {item?.vin}
                                                        </td>
                                                      </tr>
                                                    </>
                                                  );
                                                }
                                              )}
                                          </table>
                                          {(showHide[row?.permit?.id] || (showVehicleCheckboxList && row?.permit?.id === editingPermit?.id)) ? (
                                            <div>
                                              <IconButton
                                                title="Edit"
                                                onClick={() =>
                                                  handleEdit(
                                                    row?.permit?.id,
                                                    row?.vehicles,
                                                    row?.permit
                                                  )
                                                }
                                              >
                                                <Edit/>
                                              </IconButton>
                                              <IconButton
                                                title="Delete"
                                                onClick={(e) =>
                                                  handleDelete(row?.permit?.id)
                                                }
                                              >
                                                <DeleteRounded/>
                                              </IconButton>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          {showVehicleCheckboxList && row?.permit?.id === editingPermit?.id &&
                                            <div style={{marginTop: "10px"}}>
                                              <VehicleCheckboxList
                                                vehicleList={allVehicles}
                                                vehicles={editingVehicles}
                                                handleSelectVehicle={handleSelectVehicle}
                                              />
                                              <Grid container spacing={2} justifyContent="flex-end">
                                                <Grid item>
                                                  <Button
                                                    type="button"
                                                    variant="text"
                                                    color="default"
                                                    onClick={handleCancelVehicleEdit}
                                                  >
                                                    Cancel
                                                  </Button>
                                                  <Button
                                                    type="button"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleSaveVehicles}
                                                    disabled={editingVehicles.length === 0}
                                                    style={{marginLeft: "8px"}}
                                                  >
                                                    Save
                                                  </Button>
                                                </Grid>
                                              </Grid>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                          </>
                        </CardContent>
                      </Card>
                    </>
                  )}
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <Card className="thirdStepFirstDiv">
                    <CardHeader
                      className={classes.vehicleCardHeader}
                      title="Summary"
                    ></CardHeader>
                    <div style={{textAlign: "center"}}>
                      <p>
                        <b>SUBTOTAL : ${totalPrice?.toFixed(2)}</b>
                      </p>
                      <p>FEES : ${totalFee?.toFixed(2)}</p>
                      <p>TAX : ${tax.toFixed(2) || 0.00}</p>
                    </div>
                    <Divider/>
                    <p style={{textAlign: "center"}}>
                      <b>Total : ${grassTotal?.toFixed(2)}</b>
                    </p>
                  </Card>
                  {permit?.length <= 0 ? (
                    <>
                      <Container
                        style={{textAlign: "center", padding: "10px 0px"}}
                      >
                        <Button
                          variant={"contained"}
                          className="addanotherbuttons"
                          endIcon={
                            <ArrowForwardIosRounded className="borderRound"/>
                          }
                          disableElevation
                          onClick={(e) => gotochekoutCompoent(e)}
                          disabled={true}
                        >
                          Proceed to checkout
                        </Button>
                      </Container>
                    </>
                  ) : (
                    <Button
                      variant={"contained"}
                      className="addanotherbuttons"
                      endIcon={
                        <ArrowForwardIosRounded className="borderRound"/>
                      }
                      disableElevation
                      onClick={(e) => gotochekoutCompoent(e)}
                    >
                      Proceed to checkout
                    </Button>
                  )}
                </Grid>
              </Grid>
              <BuyPerimtsEditOrderModal
                isOpenExitOrderModal={isOpenExitOrderModal}
                CancelBuyPermitsExitOrderModal={CancelBuyPermitsExitOrderModal}
                ConfirmBuyPermitsExitOrderModal={ConfirmBuyPermitsExitOrderModal}
              />
              <AllowedVehicleAlertModal
                isOpenAllowedVehicleAlertModal={isOpenAllowedVehicleAlertModal}
                vehicleLimit={editingPermit}
              />
            </div>
          </Container>
        )}
      </section>
    </>
  );
}
